import type { JobSummary } from '@/types'

const SHORT_ID_LENGTH = 8

export function shortJobId(value: string, length = SHORT_ID_LENGTH): string {
  if (!value) return '—'
  if (value.length <= length) return value
  return `${value.slice(0, length)}...`
}

export function getJobNodeDisplayName(job: Pick<JobSummary, 'node_id' | 'node_name' | 'node_key'>): string {
  return job.node_name || job.node_key || shortJobId(job.node_id)
}

export function getJobNodeSecondaryText(
  job: Pick<JobSummary, 'node_name' | 'node_key' | 'node_site' | 'node_company'>,
): string | null {
  const location = [job.node_site, job.node_company].filter(Boolean).join(' / ')
  if (location) return location
  if (job.node_name && job.node_key) return job.node_key
  return null
}
